// Costanti condivise modulo Riparazioni (reception, nessun prezzo/costo)
export const RIP_STATI = [
  "Ritirato", "In diagnosi", "In lavorazione", "In attesa cliente",
  "In attesa ricambio", "In attesa lavorazione est.", "Pronto per riconsegna", "Riconsegnato", "Annullato",
];

export const RIP_STATO_COLOR = {
  "Ritirato": "bg-blue-100 text-blue-800 border-blue-200",
  "In diagnosi": "bg-violet-100 text-violet-800 border-violet-200",
  "In lavorazione": "bg-amber-100 text-amber-800 border-amber-200",
  "In attesa cliente": "bg-orange-100 text-orange-800 border-orange-200",
  "In attesa ricambio": "bg-rose-100 text-rose-800 border-rose-200",
  "In attesa lavorazione est.": "bg-cyan-100 text-cyan-800 border-cyan-200",
  "Pronto per riconsegna": "bg-teal-100 text-teal-800 border-teal-200",
  "Riconsegnato": "bg-emerald-100 text-emerald-800 border-emerald-200",
  "Chiuso": "bg-zinc-200 text-zinc-700 border-zinc-300",
  "Annullato": "bg-zinc-100 text-zinc-500 border-zinc-200",
};

export const RIP_TIPI = ["notebook", "desktop", "stampante", "smartphone", "tablet", "altro"];
export const RIP_ACCESSORI = ["alimentatore", "borsa", "mouse", "cavo", "altro"];

// Transizioni consigliate dal workflow (pulsanti rapidi)
export const RIP_NEXT = {
  "Ritirato": ["In diagnosi", "Annullato"],
  "In diagnosi": ["In lavorazione", "In attesa cliente", "In attesa ricambio", "In attesa lavorazione est."],
  "In lavorazione": ["Pronto per riconsegna", "In attesa ricambio", "In attesa cliente", "In attesa lavorazione est."],
  "In attesa cliente": ["In lavorazione", "Annullato"],
  "In attesa ricambio": ["In lavorazione"],
  "In attesa lavorazione est.": ["In lavorazione", "Pronto per riconsegna"],
  "Pronto per riconsegna": ["Riconsegnato"],
  "Riconsegnato": [],
  "Annullato": [],
};
